import {List, Typography, Grid, Box, ImageList} from '@mui/material';
import React, {ChangeEvent, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import socket, {IResponse} from '@sockets';
import SearchInput from '../search/SearchInput';
import IChannel from './IChannel';
import ChannelItem from './ChannelItem';
import MyChannelList from './MyChannelList';
import axios from 'axios';
import {appConfig} from '@config';
import {useLoaderData, Link} from 'react-router-dom';
import TopChannelItem from '@components/network/TopChannelItem';

const loadingChannel: IChannel[] = [
	{
		id: 1,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 2,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 3,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 4,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	},
	{
		id: 5,
		name: '',
		lastMessage: '',
		lastTime: new Date(),
		image: '',
		isSeen: false,
		isMember: false
	}
];

export default function Channels() {
	let channels = useLoaderData() as IChannel[];
	const [search, setSearch] = useState('');
	const [myChannels, setMyChannels] = useState<IChannel[]>(loadingChannel);
	const [topChannels, setTopChannels] = useState<IChannel[]>(loadingChannel);
	const [searchChannel, setSearchChannel] = useState<IChannel[]>(loadingChannel);
	const [searching, setSearching] = useState(false);
	const {t} = useTranslation();
	
	const handleChangeSearchFiled = (event: ChangeEvent<HTMLInputElement>) => {
		setSearch(event.target.value);
	};
	
	useEffect(() => {
		socket.emit('network:top_channels', null, (data: IResponse<IChannel[]>) => {
			if (data.success) {
				setTopChannels(data.result);
			}
		});
		// socket.emit('network:my_channels', null, (data: IResponse<IChannel[]>) => {
		// 	if (data.success) {
		// 		setMyChannels(data.result.map(channel => {
		// 			return {
		// 				...channel,
		// 				lastTime: new Date(channel.lastTime)
		// 			};
		// 		}));
		// 	}
		// });
	}, []);
	
	useEffect(() => {
		if (!search) {
			setSearchChannel(loadingChannel);
		}
		const delaySearch = setTimeout(() => {
			setSearchChannel(loadingChannel);
			if (search) {
				setSearching(true);
				socket.emit('network:search_channel', search, (data: IResponse<IChannel[]>) => {
					setSearching(false);
					if (data.success) {
						setSearchChannel(data.result);
					}
				});
			}
		}, 1000);
		
		return () => clearTimeout(delaySearch);
	}, [search]);
	
	const handleJoinChannel = (channel: IChannel) => {
		setTopChannels(topChannels.filter(c => c.id !== channel.id));
		setMyChannels([channel, ...myChannels]);
	};
	
	return (
		<div className="felx flex-col space-y-2 mx-5">
			<SearchInput placeholder={t('search_channel_placeholder')} value={search} onChange={handleChangeSearchFiled}/>
			<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50'}}
			            className="font-medium pt-4">{t('top_channels')}</Typography>
			<Box sx={{flexGrow: 1}}>
				<ImageList className="w-full h-auto flex flex-row flex-wrap justify-between">
					{
						topChannels.map(channel => <TopChannelItem key={channel.id} channel={channel} onJoin={handleJoinChannel}/>)
					}
				</ImageList>
			</Box>
			{
				searching || searchChannel !== loadingChannel ?
					<List>
						{
							searchChannel.map(channel => <ChannelItem key={channel.id} channel={channel} onJoin={handleJoinChannel}/>)
						}
					</List>
					:
					<>
						<div className="w-full flex flex-row justify-between pt-4">
							<Typography sx={{
								color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50',
								fontSize: (theme) => theme.typography.fontSize
							}}
							            className="font-medium">{t('all_channels')}</Typography>
							<Link to={'/network'}>
								<Typography
									sx={{
										color: (theme) => theme.palette.mode === 'light' ? 'primary.900' : 'secondary50',
										fontSize: (theme) => theme.typography.fontSize
									}}
									className="font-medium">{t('my_channels')}</Typography>
							</Link>
						</div>
						<List className="py-0">
							{
								channels.map(channel => <ChannelItem key={channel.id} channel={channel} onJoin={handleJoinChannel}/>)
							}
						</List>
					</>
			}
		</div>
	);
}


interface loader {
	request: Request;
	params: {};
}

export async function channelsLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.base.url}/channels`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
